import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { Layout } from "../../layout";
import { IpSetList } from "./list";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { IpSetCreateInitializer } from "./create/initializer";
import { IpSetDetailInitializer } from "./detailInitializer";

const IpSetRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<IpSetList />} />
        <Route path={`-create/*`} element={<IpSetCreateInitializer />} />
        <Route path={`:ipset/*`} element={<IpSetDetailInitializer />} />
      </Routes>
    </Layout>
  );
};

export default IpSetRoute;
